import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook } from '@fortawesome/free-solid-svg-icons';
import Button from '../SideButtons/Button';

interface Props {
  onClick: () => void;
}

const BBBResourceButton = ({ onClick }: Props) => {
  return <Button label="Resources" onClick={onClick} icon={<FontAwesomeIcon icon={faBook} />} />;
};

export default BBBResourceButton;
